import React, { Component } from 'react'

class Visualiser extends Component {
    constructor() {
        super()
        this.state = {
            total_nodes: '',
            total_edges: '',
            starting_node: '',
            isWeighted: false,
            vertices: [],
            edges: [],
            graph: [],
            height: window.innerHeight,
            width: window.innerWidth,
            algorithm: '',
            speed: 800,
            id : [],
            radius: Math.floor((4*Math.floor(window.innerWidth / 100) + Math.floor(window.innerHeight / 100)) / 4),
            errors: {},
        }
        this.onChangeNodes = this.onChangeNodes.bind(this)
        this.onChangeEdges = this.onChangeEdges.bind(this)
        this.OnSimulate = this.OnSimulate.bind(this)
        this.sleep = this.sleep.bind(this)
    }

    onChangeNodes(e) {
        let nodes = e.target.value
        this.setState({ [e.target.name]: nodes })
        let data = []
        let w = this.state.width
        let h = this.state.height
        for (let i = 0; i < nodes; i++) {
            let num1 = 2 * this.state.radius + Math.floor(Math.random() * w * 0.7)
            let num2 = this.state.radius + Math.floor(Math.random() * h * 0.8)
            let node_data = {
                x: num1,
                y: num2,
                color: "blue"
            }
            data.push(node_data)
        }
        this.setState({ vertices: data })
    }

    onChangeEdges(e) {

        let total_edges = e.target.value
        let nodes = this.state.total_nodes
        if (2 * total_edges > (nodes * (nodes - 1))) {
            alert('Edges can not be greater than (n * n+1) / 2')
            return;
        }

        this.setState({ [e.target.name]: total_edges })
        let set = new Set()

        let edges = []
        let data = []
        for (let j = 0; j < this.state.total_nodes; j++) {
            data.push([])
        }

        for (let i = 0; i < total_edges; i++) {

            let num1 = Math.floor(Math.random() * this.state.total_nodes)
            let num2 = Math.floor(Math.random() * this.state.total_nodes)

            let str1 = num1.toString() + '#' + num2.toString()
            let str2 = num2.toString() + '#' + num1.toString()

            if (set.has(str1) || set.has(str2) || num1 === num2) {
                i -= 1
            }
            else {
                set.add(str1)
                let weight_edge = Math.floor(Math.random() * 100)
                data[num1].push({ node : num2, weight : weight_edge })
                data[num2].push({ node : num1, weight: weight_edge })
                edges.push({
                    u: num1,
                    v: num2,
                    weight: weight_edge,
                    color: "yellow"
                })
            }
        }
        this.setState({ edges: edges })
        this.setState({ graph: data })
    }

    onChangeWeighted(e) {
        let check_weighted = e.target.value === "true" ? true : false
        this.setState({ isWeighted: check_weighted })
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    onChangeStartingNode(e) {
        let node = e.target.value;
        node = parseInt(node)
        if (node >= this.state.vertices.length || node < 0) {
            alert('starting node should be between 0 to n');
            return;
        }
        else if (node < this.state.vertices.length && node >= 0) {
            this.setState(state => {
                return state.vertices.map((item, index) => {
                    if (node === index) {
                        item.color = "black"
                        return item;
                    } else {
                        item.color = "blue"
                        return item;
                    }
                });
            });
            this.setState({ starting_node: node })
        }

    }

    OnSimulate(e) {
        e.preventDefault()
        let graph, check, i;
        if (this.state.algorithm === "bfs") {
            graph = this.state.graph;
            check = [];
            for (i = 0; i < graph.length; i++) {
                check.push(false)
            }
            this.BFS(this.state.starting_node, this.state.graph, check)
        }

        if (this.state.algorithm === "dfs") {
            graph = this.state.graph;
            check = [];
            for (i = 0; i < graph.length; i++) {
                check.push(false)
            }
            this.DFS(this.state.starting_node, this.state.graph, check)
        }

        if (this.state.algorithm === "mst") {
            this.PrimMST()
        }

        if (this.state.algorithm === "dijkstra") {
            graph = this.state.graph;
            check = [];
            for (i = 0; i < graph.length; i++) {
                check.push(false)
            }
            this.Dijkstra(this.state.starting_node, this.state.graph, check)
        }

        if (this.state.algorithm === "coloring") {
            graph = this.state.graph;
            this.GraphColouring(graph)
        }
    }

    sleep = () => {
        return new Promise(resolve => setTimeout(resolve, this.state.speed))
    }

    BFS = async (x, graph, check) => {
        let q = [];
        q.push(x);
        check[x] = true
        while (q.length > 0) {
            let k = q.shift()
            for (let i = 0; i < graph[k].length; i++) {
                if (!check[graph[k][i].node]) {
                    await this.setState(state => {
                        return state.edges.map((item, index) => {
                            if ((item.v === k && item.u === graph[k][i].node) || (item.u === k && item.v === graph[k][i].node)) {
                                item.color = "#e35417"
                                return item;
                            } else {
                                return item;
                            }
                        });
                    });
                    await this.setState(state => {
                        return state.vertices.map((item, index) => {
                            if (graph[k][i].node === index && item.color !== "black") {
                                item.color = "green"
                                return item;
                            } else {
                                return item;
                            }
                        });
                    });
                    await this.sleep()
                    check[graph[k][i].node] = true;
                    q.push(graph[k][i].node);
                }
            }
        }
    }

    DFS = async (x, graph, check) => {
        check[x] = true
        for (let i = 0; i < graph[x].length; i++) {
            if (!check[graph[x][i].node]) {
                await this.setState(state => {
                    return state.edges.map((item, index) => {
                        if ((item.v === x && item.u === graph[x][i].node) || (item.u === x && item.v === graph[x][i].node)) {
                            item.color = "#e35417"
                            return item;
                        } else {
                            return item;
                        }
                    });
                });
                await this.setState(state => {
                    return state.vertices.map((item, index) => {
                        if (graph[x][i].node === index && item.color !== "black") {
                            item.color = "green"
                            return item;
                        } else {
                            return item;
                        }
                    });
                });
                await this.sleep()
                await this.DFS(graph[x][i].node, graph, check);
            }
        }
    }

    GraphColouring = async (graph) => {
        let color = ["CYAN", "GREEN", "RED", "YELLOW", "ORANGE", "PINK", "BLACK", "BROWN", "PURPLE", "VOILET"]
        let result = {};
        for (let i = 0; i < this.state.total_nodes; i++) {
            result[i] = "BLUE"
        }
        for (let i = 0; i < this.state.total_nodes; i++) {
            let assigned = [];
            for (let j = 0; j < this.state.graph[i].length; j++) {
                if (result[graph[i][j]] != "BLUE") {
                    assigned.push(result[graph[i][j].node]);
                }
            }
            let colorind = 0;
            for (let j = 0; j < color.length; j++) {
                let mark = 0;
                for (let k = 0; k < assigned.length; k++) {
                    if (color[j] == assigned[k]) {
                        mark = 1;
                    }
                }
                if (mark == 0) {
                    colorind = j;
                    break;
                }
            }
            result[i] = color[colorind];
            await this.setState(state => {
                return state.vertices.map((item, index) => {
                    item.color = result[index]
                    return item;
                });
            });
            await this.sleep()
        }
    }

    root = (x) => {
        let id = this.state.id 
        while (id[x] != x) {
            id[x] = id[id[x]];
            x = id[x];
        }
        this.setState({id : id})
        return x;
    }


    PrimMST = async () => {

        let edges = this.state.edges
        let sz = this.state.vertices.length

        let id = [];
        for (let i = 0; i < sz; i++) {
            id.push(i);
        }
        await this.setState({ id: id })

        for (let i = 0; i < edges.length - 1; i++) {
            for (let j = i + 1; j < edges.length; j++) {
                if (edges[i].weight > edges[j].weight) {
                    let temp = edges[i]
                    edges[i] = edges[j]
                    edges[j] = temp
                }
            }

        }
        

        for (let i = 0; i < edges.length ; i++) {

            if(i===edges.length - 1){
                await this.setState(state => {
                    return state.edges.map((item, index) => {
                        if (item.color === "yellow") {
                            item.color = "white"
                            item.weight = ''
                            return item;
                        }
                        else
                            return item
                    });
                });
                return;
            }
            let root1 = await this.root(edges[i].u) 
            let root2 = await this.root(edges[i].v)
            
            if (root1 != root2) {
                let id = this.state.id
                id[root1] = id[root2];
                await this.setState({ id: id })
                await this.setState(state => {
                    return state.edges.map((item, index) => {
                        if (item.u == edges[i].u && item.v == edges[i].v) {
                            item.color = "#e35417"
                            return item;
                        }
                        else {
                            return item;
                        }

                    });
                });
                
                await this.sleep()
            }
        }

    }

    Dijkstra = async (x, graph, check) => {
        
        let distance = [];
        let par = []
        let done = []
        for (let i = 0; i <= this.state.total_nodes; i++) {
            distance[i] = 1000;
            par[i] = -1
            done[i] = false
        }
        distance[x] = 0;

        let q = []
        q.push(x)
        check[x] = true
        let d = 5
        while (true) {
            d -= 1
            let k = q[0]
            let cnt = 0
            for (let j = 0; j < q.length; j++) {
                if (!done[q[j]]) cnt += 1
                if ((distance[q[j]] < distance[k]) && (!done[q[j]])) k = q[j]
            }
            if (cnt === 0) break
            done[k] = true
            for (let j = 0; j < q.length; j++) {
                if (q[j] === k) q.splice(j, 1)
            }
            
            this.setState(state => {
                return state.vertices.map((item, index) => {
                    if (k === index && item.color !== "black") {
                        item.color = "green"
                        return item;
                    } else {
                        return item;
                    }
                });
            });
            
            for (let i = 0; i < graph[k].length; i++) {
                if (!check[graph[k][i].node]) {
                    check[graph[k][i].node] = true
                    q.push(graph[k][i].node)
                }
                if (!done[graph[k][i].node]) {
                    if (distance[k] + graph[k][i].weight < distance[graph[k][i].node]) {
                        distance[graph[k][i].node] = distance[k] + graph[k][i].weight 
                        await this.setState(state => {
                            return state.edges.map((item, index) => {
                                if ((item.v === par[graph[k][i].node] && item.u === graph[k][i].node) || (item.u === par[graph[k][i].node] && item.v === graph[k][i].node)) {
                                    item.color = "yellow"
                                    return item;
                                } else {
                                    return item;
                                }
                            });
                        });
                        par[graph[k][i].node] = k
                        await this.setState(state => {
                            return state.edges.map((item, index) => {
                                if ((item.v === par[graph[k][i].node] && item.u === graph[k][i].node) || (item.u === par[graph[k][i].node] && item.v === graph[k][i].node)) {
                                    item.color = "#e35417"
                                    return item;
                                } else {
                                    return item;
                                }
                            });
                        });
                        await this.sleep()
                    }
                }
            }
        }

    }

    render() {

        const { vertices, radius } = this.state

        const parameterCss = {
            height: "90vh",
            border: "1px solid #a2c48d",
            boxShadow: "2px 2px 3px #bfbfbf",
            borderRadius: "10px",
            position: "fixed",
            width: "23%",
            overflowY: "scroll",
            marginLeft : "1%"
        }

        const simulatorCss = {
            height: "90vh",
            border: "1px solid #a2c48d",
            boxShadow: "2px 2px 3px #bfbfbf",
            borderRadius: "10px",
            left: "25%",
            width: "74%",
            position: "fixed",
        }

        const inputCss = {
            border: "1px solid #a2c48d",
            borderRadius : "5px",
            boxShadow: "2px 2px 3px #bfbfbf",
            height: 2*radius,
            width: "75%",
            fontSize: Math.floor(0.8 * radius)
        }


        return (
            <div className="visualiser my-2"
            >
                <div className="scroll parameter" style={parameterCss}>
                    <div style={{ color: "#a2c48d", fontSize: Math.floor(1.5 * radius), textAlign: "center" }}>
                        Input parameters
                    </div>
                    <div style={{ color: "#996560", fontSize: radius, fontWeight: "600", paddingLeft: "25px", paddingTop : "20px" }}>
                        <div className="form-group" >
                            Total number of nodes
                            <input
                                type="number"
                                className="form-control"
                                name="total_nodes"
                                required
                                value={this.state.total_nodes}
                                onChange={this.onChangeNodes}
                                style={inputCss}
                            />
                        </div>

                        <div className="form-group">
                            <label >Total number of edges</label>
                            <input
                                type="number"
                                className="form-control"
                                name="total_edges"
                                required
                                value={this.state.total_edges}
                                onChange={this.onChangeEdges}
                                style={inputCss}
                            />
                        </div>

                        <div className="form-group">
                            Weighted Graph<br></br>
                            <select
                                name="isWeighted"
                                required
                                value={this.state.isWeighted}
                                onChange={(e) => this.onChangeWeighted(e)}
                                style={inputCss}
                            >
                                <option value={false}>No</option>
                                <option value={true}>Yes</option>

                            </select>
                        </div>

                        <div className="form-group" >
                            Starting node
                            <input
                                type="number"
                                className="form-control"
                                name="starting_node"
                                required
                                value={this.state.starting_node}
                                min="0"
                                max={vertices.length - 1}
                                onChange={(e) => this.onChangeStartingNode(e)}
                                style={inputCss}
                            />
                        </div>

                        <div className="form-group">
                            Algorithm<br></br>
                            <select
                                name="algorithm"
                                required
                                value={this.state.algorithm}
                                onChange={(e) => this.onChange(e)}
                                style={inputCss}
                            >
                                <option value='' disabled>Select..</option>
                                <option value='dfs'>DFS</option>
                                <option value='bfs'>BFS</option>
                                <option value='mst'>MST</option>
                                <option value='dijkstra'>Dijkstra</option>
                                <option value='coloring'>Graph coloring</option>
                            </select>
                        </div>
                        <div>
                            <button className="btn" style={{
                                backgroundColor: "#f8fcf5",
                                color: "black",
                                width: "75%",
                                fontSize: radius,
                            }}
                                onClick={() => this.setState({
                                    total_nodes: '',
                                    total_edges: '',
                                    starting_node: '',
                                    isWeighted: false,
                                    vertices: [],
                                    edges: [],
                                    graph: [],
                                    algorithm: '',
                                    height: window.innerHeight,
                                    width: window.innerWidth,
                                    radius: Math.floor((4 * Math.floor(window.innerWidth / 100) + Math.floor(window.innerHeight / 100)) / 4)
                                })}
                            >
                                Clear board
                            </button>
                        </div>
                        <div>

                        </div>
                        <div>
                            <button className="btn" style={{
                                backgroundColor: "#effce8",
                                color: "black",
                                width: "90%",
                                borderRadius: "0px 20px 20px 0px",
                                marginTop: "20px",
                                fontSize: Math.floor(1.3 * radius),
                            }}
                                onClick = {this.OnSimulate}
                            >
                                Simulate
                            </button>
                        </div>
                    </div>
                </div>
                <div className="simulator" style={simulatorCss}>
                    <div style={{ color: "#a2c48d", fontSize: Math.floor(1.5 * radius), textAlign: "center" }}>
                        Siumlation
                    </div>
                    <svg width="100%" height="90vh">

                        {this.state.edges ? (
                            this.state.edges.map((data, index) => (
                                <line key={`"edge"${index}`} x1={vertices[data.v].x} y1={vertices[data.v].y} x2={vertices[data.u].x} y2={vertices[data.u].y}
                                    style={{ stroke: data.color, strokeWidth: Math.floor(radius/4) + 1, zIndex: 1 }}
                                />
                            ))
                        ) : ''}

                        {this.state.isWeighted ? (
                            this.state.edges.map((data, index) => (
                                <text key={`"weight"${index}`} x={(vertices[data.v].x + vertices[data.u].x) / 2} y={(vertices[data.v].y + vertices[data.u].y) / 2} fill="red" style={{ fontWeight: "bold", fontSize: Math.floor(2*radius)/3 }}>
                                    {data.weight}
                                </text>
                            ))
                        ) : ''}

                        {vertices ? (
                            vertices.map((data, index) => (
                                <circle className="circle" key={`"node"${index}`} cx={data.x} cy={data.y}
                                    r={radius} fill={data.color}
                                />

                            ))
                        ) : ''}

                        {vertices ? (
                            vertices.map((data, index) => (
                                <text key={`"text"${index}`} x={data.x - Math.floor(radius / 3)} y={data.y + Math.floor(radius / 3)} fill="white" style={{ fontWeight: "bold", fontSize: radius }}>
                                    {index}
                                </text>
                            ))
                        ) : ''}

                    </svg>
                </div>
            </div>
        )
    }
}
export default Visualiser;